import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { Plus } from 'lucide-react';

const FloatingActionButton = () => {
  return (
    <div
      style={{
        position: 'fixed',
        bottom: '2rem',
        right: '2rem',
        zIndex: 1000
      }}
    >
      <Button
        as={Link}
        to="/prompts/create"
        variant="primary"
        size="lg"
        className="rounded-circle shadow-lg"
        style={{
          width: '60px',
          height: '60px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        title="Create New Prompt"
      >
        <Plus size={24} />
      </Button>
    </div>
  );
};

export default FloatingActionButton;
